import { CommonModule } from "@angular/common";
import { Component, Input, OnInit } from "@angular/core";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { MESSAGEWAIT4SIGN } from "@shared/constants/localstorage.constants";
import { PolicyWait4SignEndorsement } from "@shared/models/policy-wait4sign-endorsement.model";
import { MessagesService } from "@shared/services/messages.service";
import { PolicyRecoveryService } from "@shared/services/policy-recovery.service";
import { PolicyService } from "@shared/services/policy.service";
import { Message } from "primeng/api";
import { ButtonModule } from "primeng/button";
import { MessagesModule } from "primeng/messages";
import { ToastModule } from "primeng/toast";

@Component({
  selector: "app-message-wait4sign-alert",
  standalone: true,
  imports: [CommonModule, MessagesModule, ToastModule, TranslateModule, ButtonModule],
  templateUrl: "./message-wait4sign-alert.component.html",
  styleUrl: "./message-wait4sign-alert.component.scss",
})
export class MessageWait4signAlertComponent implements OnInit {
  @Input() showMessage = false;
  message!: Message;
  policyList: PolicyWait4SignEndorsement[] = [];

  constructor(
    private messagesService: MessagesService,
    private policyRecoveryService: PolicyRecoveryService,
    private policyService: PolicyService,
    private translateService: TranslateService
  ) {}

  ngOnInit(): void {
    const messageClosed = localStorage.getItem(MESSAGEWAIT4SIGN) === "true";
    this.showMessage = !messageClosed && this.showMessage;
    this.messagesService.currentMessage.subscribe(message => {
      this.message = message;
      if (!messageClosed) {
        this.showMessage = true;
      }
    });
    this.getPolicyWait4SignList();
  }

  getPolicyWait4SignList() {
    this.policyService.getPolicyWait4SignEndorsement().subscribe({
      next: policies => {
        this.policyList = policies;
        const message = {
          severity: "info",
          detail: this.translateService.instant("common.wait4SignMessage"),
        };
        this.message = message;
      },
      error: error => {
        console.error("Erreur lors de la récupération des polices", error);
      },
    });
  }

  onReturnToDocument() {
    //Débranchement vers parcours
    this.policyRecoveryService.getSignatureUrls(this.policyList);
  }

  closeMessage() {
    this.showMessage = false;
    localStorage.setItem(MESSAGEWAIT4SIGN, "true");
  }
}
